<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl mr20">
        <div class="fl lh30">品牌：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="elementParams.brandId"
            style="width: 120px"
            @change="getTableList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in brands"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">渠道：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="elementParams.channelId"
            style="width: 120px"
            @change="getTableList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in channels"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl  mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="elementParams.siteId"
            style="width: 120px"
            @change="getTableList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in sites"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl">
        <div class="fl lh30">终端：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="elementParams.terminalId"
            style="width: 120px"
            @change="getTableList"
          >
            <a-select-option :value="1" key="web">WEB</a-select-option>
            <a-select-option :value="2" key="app">APP</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div class="fourElementsContainer">
      <div class="oh fl mr20">
        <div class="fl lh30">实验层名称：</div>
        <div class="fl">
          <a-input
            style="width: 120px"
            v-model:value="elementParams.name"
            placeholder="请输入实验层名称"
            allowClear
            @pressEnter="getTableList"
          />
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">实验名：</div>
        <div class="fl">
          <a-input
            style="width: 120px"
            v-model:value="elementParams.experimentName"
            allowClear
            placeholder="请输入实验名称"
            @pressEnter="getTableList"
          />
        </div>
      </div>
      <div class="oh fl  mr20">
        <div class="fl lh30">创建人：</div>
        <div class="fl">
          <a-select
            ref="select"
            style="width: 180px"
            v-model:value="elementParams.creater"
            allowClear
            placeholder="请输入创建人"
            @change="getTableList"
            show-search
            optionFilterProp="label"
            :options="userList"
          >
          </a-select>
        </div>
      </div>
    </div>
    <div class="fourElementsContainer right">
      <a-button type="primary" class="btn mr10" @click="getTableList"
        >查询</a-button
      >
      <a-button type="default" @click="resetFormData">重置</a-button>
      <a-button type="primary" class="btn" @click="createNewLayer"
        >新建实验层</a-button
      >
    </div>
  </div>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
import { user_list } from '@/server/modules/filter'

export default {
  setup() {
    const initData = inject('initState')
    let userList = ref([])
    async function getUserList() {
      const { success, data } = await user_list()
      if (success) {
        userList.value = data.map(item => ({
          label: item.name,
          value: item.name
        }))
      }
    }
    getUserList()

    return {
      userList,
      ...toRefs(initData)
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px;
  margin: 20px;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
}
.fourElementsContainer.right {
  justify-content: flex-end;
}

.btn {
  margin-left: 10px;
}
</style>
